const sizeClasses = {
  sm: "size-9",
  md: "size-10",
  lg: "size-[42px]",
};

const variantClasses = {
  soft:
    "bg-[#F3F4F6] text-[#2563EB] hover:bg-[#EFF6FF] focus-visible:ring-[#2563EB]/25",
  ghost:
    "bg-transparent text-[#2563EB] hover:bg-[#EFF6FF] focus-visible:ring-[#2563EB]/25",
  onDark:
    "bg-transparent text-white hover:bg-white/10 focus-visible:ring-white/70",
};

const BackButton = ({
  ariaLabel,
  className = "",
  disabled = false,
  iconClassName = "",
  label,
  onClick,
  size = "lg",
  title,
  type = "button",
  variant = "soft",
  ...props
}) => {
  const accessibleLabel = ariaLabel || label || "Quay lại";
  const iconFilter = variant === "onDark" ? "brightness-0 invert" : "";

  return (
    <button
      type={type}
      aria-label={accessibleLabel}
      title={title || accessibleLabel}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={[
        "inline-flex shrink-0 items-center justify-center rounded-lg font-sf-medium text-sm transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-60",
        label ? "min-h-[42px] gap-2 px-3" : sizeClasses[size] || sizeClasses.lg,
        variantClasses[variant] || variantClasses.soft,
        className,
      ].join(" ")}
      {...props}
    >
      <img
        src="/icons/left-arrow.svg"
        alt=""
        aria-hidden="true"
        className={["size-5", iconFilter, iconClassName].join(" ")}
      />
      {label && <span className="whitespace-nowrap">{label}</span>}
    </button>
  );
};

export default BackButton;
